




















































import {Component, Prop} from 'vue-property-decorator';
import Modal from "./Modal.vue";
import CommonVue from "../models/commonVue";
import ApiList from "@/api/list";
import Module from "@/api/module";
import Dimmer from "@/components/Dimmer.vue";
import DropDownEntity from "@/components/DropDownEntity.vue";
import Lesson from "@/api/lesson";

@Component({
    components: {
        'modal': Modal,
        'drop-down-entity': DropDownEntity,
        'dimmer': Dimmer,
    },
})
export default class ChangeModule extends CommonVue{
    @Prop({type: Lesson}) public lesson!: Lesson;
    public moduleList: ApiList<Module> = null;

    public showModal: boolean = false;

    public async beforeMount() {
        await this.load();
    }

    private async load() {
        this.moduleList = await Module.listAll();
    }

    public async show() {
        this.showModal = true;
    }

    public async saveClicked() {
        const confirm = this.askConfirmation();
        if (confirm) {
            this.lesson.parent_submodule = undefined;
            this.lesson.order = (await Lesson.getLessonsOfModule(this.lesson.parent_module)).count;
            await this.lesson.save();
            this.showModal = false;
        }
    }

    private askConfirmation() {
        let answer = false;
        if((this.lesson || !(this.lesson === undefined)))
            answer = window.confirm('Do you really want to move this lesson?');
        return answer;
    }
}
